import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() currentPage: number = 1;
  @Input() hasMore: boolean = true;

  @Output() pageChange = new EventEmitter<number>();

  prevPage() {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.hasMore) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  getVisiblePages(): number[] {
    const pages: number[] = [];

    if (this.currentPage <= 3) {
      const end = this.hasMore ? 3 : this.currentPage;
      for (let i = 2; i <= end; i++) {
        pages.push(i);
      }
    } else {
      pages.push(this.currentPage - 1, this.currentPage);
      if (this.hasMore) {
        pages.push(this.currentPage + 1);
      }
    }

    return [...new Set(pages)].filter(p => p > 1);
  }


  onPageClick(page: number, event: Event): void {
    event.preventDefault();
    if (page !== this.currentPage) {
      this.pageChange.emit(page);
    }
  }

}
